<template>
  <div class="fill-height">
    <NavigationDrawer />
    <router-view ref="project"></router-view>
    <YearDialog></YearDialog>
    <UploadDoneDialog></UploadDoneDialog>
  </div>
</template>

<script>
import NavigationDrawer from '@/components/app/NavigationDrawer.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import YearDialog from '@/components/year/YearDialog.vue'
import UploadDoneDialog from '@/components/dike/UploadDoneDialog.vue'
import { useEventsBus } from '@haskoning/vue-component-library'
const { emit } = useEventsBus()

export default {
  name: 'ProjectDetailView',
  components: { YearDialog, NavigationDrawer, UploadDoneDialog },
  props: {},
  computed: {
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    ...mapGetters('users', {
      accessibleProject: 'getAccessibleProject'
    })
  },
  methods: {
    ...mapActions('project', {
      fetchProject: 'fetchProject',
      resetProjectState: 'resetState',
      toggleProjectLoading: 'toggleLoading'
    }),
    ...mapActions('years', {
      fetchYears: 'fetchItems'
    }),
    ...mapActions('referencePoint', {
      fetchReferencePoints: 'fetchAll',
      resetReferencePointState: 'resetState'
    }),
    ...mapActions('dikeSection', {
      fetchDikeSections: 'fetchAll',
      resetDikeSectionState: 'resetState'
    }),
    ...mapActions('stabSchematisation', {
      fetchStabSchematisations: 'fetchItemsAdd'
    }),
    ...mapActions('dikeProfiles', {
      fetchDikeProfiles: 'fetchAll',
      resetDikeProfilesState: 'resetState'
    }),
    ...mapActions('settlement', {
      resetStateSettlement: 'resetState'
    }),
    ...mapActions('stabSchematisation', {
      resetStateStabSchematisation: 'resetState'
    }),
    ...mapActions('crestLevelBoundaryCondition', {
      resetStateCrestLevelBoundaryCondition: 'resetState'
    }),
    ...mapActions('hydraulicHeadBoundaryCondition', {
      resetStateHydraulicHeadBoundaryCondition: 'resetState'
    }),
    ...mapActions('riverWaterLevel', {
      resetStateRiverWaterLevel: 'resetState'
    }),
    resetMapState() {
      this.resetDikeSectionState()
      this.resetReferencePointState()
      this.resetDikeProfilesState()
    },
    resetBoundaryConditionState() {
      this.resetStateSettlement()
      this.resetStateCrestLevelBoundaryCondition()
      this.resetStateHydraulicHeadBoundaryCondition()
      this.resetStateRiverWaterLevel()
    }
  },
  async mounted() {
    if (this.currentProject.id === '' || this.$route.params.id !== this.currentProject.id) {
      this.resetBoundaryConditionState()
      await this.resetProjectState()
      this.resetMapState()
      await this.resetStateStabSchematisation()
      try {
        await this.fetchProject(this.$route.params.id)
      } catch (error) {
        this.toggleProjectLoading()
        this.$router.push({ name: 'project-index' })
      }
      if (this.$route.params.id) {
        await this.fetchYears(this.$route.params.id)
        await this.fetchDikeSections(this.$route.params.id)
        await this.fetchReferencePoints(this.$route.params.id)
        await this.fetchDikeProfiles(this.$route.params.id)
        await this.fetchStabSchematisations(this.$route.params.id)
      }
    }
    emit('project-loaded')
  }
}
</script>
